import React from 'react';
import SkillsSection from './SkillsSection';

const ProfessionalSkills = ({ data }) => {
  return (
    <>
      <div className="col-span-12 px-10 py-10 pb-4">
        <div className="font-bold" style={{ fontSize: 32 }}>
          Professional skills
        </div>
      </div>
      <div className="col-span-12 px-6 py-6 pt-3">
        <div style={{ borderBottom: '2px solid #D3D3D3' }}>
          <div className="flex align-center mb-2 w-full" style={{ width: '100%' }}>
            <div style={{ width: '70%' }} className="text-left ml-3">
              <div className="font-semibold tracking-wide text-left" style={{ fontSize: 14 }}>
                SKILLS
              </div>
            </div>
            <div style={{ width: '15%' }} className="text-right">
              <div className="font-semibold tracking-wide text-center" style={{ fontSize: 14 }}>
                EXPERIENCE IN YEARS
              </div>
            </div>
            <div style={{ width: '15%' }} className="text-right mr-3">
              <div className="font-semibold tracking-wide text-right" style={{ fontSize: 14 }}>
                LEVEL
              </div>
            </div>
          </div>
          <SkillsSection
            data={data}
            sectionKey="programmingLanguages"
            title="Programming languages"
          />
          <SkillsSection data={data} sectionKey="ideOrTools" title="IDE/Development Tools" />
          <SkillsSection
            data={data}
            sectionKey="developmentTechnologies"
            title="Development Technologies"
          />
          <SkillsSection data={data} sectionKey="ciCdTools" title="CI/CD Tools" />
          <SkillsSection
            data={data}
            sectionKey="versionControlSystems"
            title="Version Control Systems"
          />
          <SkillsSection data={data} sectionKey="iOsTechnologies" title="iOS Technologies" />
          <SkillsSection
            data={data}
            sectionKey="androidTechnologies"
            title="Android Technologies"
          />
          <SkillsSection
            data={data}
            sectionKey="developmentMethodologies"
            title="Development Methodologies"
          />
          <SkillsSection data={data} sectionKey="dataBases" title="Databases" />
          <SkillsSection data={data} sectionKey="other" title="Other Skills" />
        </div>
      </div>
    </>
  );
};

export default ProfessionalSkills;
